import usegetdata from '../../Hooks/useGetData';
import {
  Get_Error,
  Get_Markiting_Reports_campaign,
  Important_Marketing_Reports_Type,
  Lead_Preview,
} from '../Types';

//get allCampaigns Reports

export const Get_All_Marketing_Reports_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Campain/marketing-report`);

    dispatch({
      type: Get_Markiting_Reports_campaign,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Get_Important_Marketing_Reports_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Campain//important-marketing-report`);

    dispatch({
      type: Important_Marketing_Reports_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get Leads Preview

export const Get_All_Leads_Preview_Action = (Leadid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/Lead-Full_Data/${Leadid}`);

    dispatch({
      type: Lead_Preview,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
